import React, { useState } from 'react';
import { social } from '../utils/constants';
import styled from 'styled-components';

export default function Contact() {
  const [status, setStatus] = useState('Submit');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    // const { name, email, message } = e.target.elements;

    let details = {
      name: name,
      email: email,
      message: message,
    };

    let response = await fetch('http://localhost:3000/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify(details),
    });

    setStatus('Submit');
    let result = await response.json();
    alert(result.status);
  };

  return (
    <ContactContainer>
      <h1>Contact functionaliteit NOK</h1>
      <p className='contact-info '>
        U kan ons bereiken via de volgende contact mogelijkheden
      </p>
      <br />
      <h2>Bellen / Whatsapp</h2>
      <p className='contact-info '>+32 479 83 52 35</p>
      <br />
      <h2>Sociale media</h2>
      <div>
        <ul className='social-icons'>
          {social.map((socialIcon) => {
            const { id, url, icon } = socialIcon;
            return (
              <li key={id}>
                <a href={url}>{icon}</a>
              </li>
            );
          })}
        </ul>
      </div>
      <br />
      <h2>Bericht</h2>
      <div className='form'>
        <form onSubmit={handleSubmit} className='form-form'>
          <div>
            <label htmlFor='name'>Name:</label>
            <br />
            <input
              type='text'
              id='name'
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor='email'>Email: </label>
            <br />
            <input
              type='text'
              id='email'
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor='message'>Message: </label>
            <br />
            <textarea
              name='message'
              id='message'
              cols='65'
              rows='10'
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button type='submit' className='btn-primary'>
            {status}
          </button>
        </form>
      </div>
    </ContactContainer>
  );
}

const ContactContainer = styled.div`
  background: var(--primaryLessonsColor);
  margin-bottom: 2rem;
  h1,
  h2 {
    color: var(--primaryBtnColor);
  }
  .contact-info {
    text-align: center;
    color: var(--primaryTxtColor);
  }
  .social-icons {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .social-icons a {
    margin: 0 0.5rem;
    color: var(--primaryFooterColor);
    transition: var(--transition);
  }
  .social-icons a:hover {
    color: var(--primaryTxtColor);
  }
  .form {
    display: flex;
    flex-direction: column;
    width: var(--inputWidth);
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }

  .form input {
    border: none;
    width: 500px;
    border-bottom: 2px solid var(--darkGrey);
    margin-bottom: 1.25rem;
    padding: 0.5rem;
    font-size: 1.2rem;
  }
  .form button {
    width: 100%;
  }
`;
